import React, { useEffect } from 'react';
import styled from '@emotion/styled';
// import Footer from './footer/Footer';
import Header from './header/Header';
import Seo from './Seo';
import {
  HEADER_HEIGHT,
  BODY_WIDTH,
  FOOTER_HEIGHT,
  MOBILE_FOOTER_HEIGHT,
  FOOTER_ROAD_HEIGHT,
} from '../../styles/constants/size';
import { useRouter } from 'next/router';
import AlertArea from './AlertArea';
import BackgroundArea from './BackgroundArea';

const Body = styled.section<{ pathname: string }>`
  width: ${BODY_WIDTH};
  height: auto;
  min-height: calc(
    100vh - ${FOOTER_HEIGHT} - ${props => (props.pathname === '/' ? FOOTER_ROAD_HEIGHT : '0px')}
  );
  padding-top: calc(${HEADER_HEIGHT} + 20px);
  padding-bottom: 20px;
  margin: 0 auto;

  @media (max-width: 1032px) {
    width: 100vw;
    margin: 0;
    padding-left: 8px;
    padding-right: 8px;
  }

  @media (max-width: 768px) {
    height: -webkit-fill-available;
    height: fill-available;
    min-height: calc(100vh - ${MOBILE_FOOTER_HEIGHT});
  }

  @media print {
    display: none;
  }
`;

interface Props {
  children: React.ReactNode;
}

/**
 * @descritpion 공통 레이아웃 컴포넌트
 * @param {React.ReactNode} children 페이지의 내용을 표현할 자식 컴포넌트
 *  */
function Layout({ children }: Props): JSX.Element {
  const { pathname } = useRouter();

  useEffect(() => {
    const script: HTMLScriptElement = document.createElement('script');
    script.src = 'https://developers.kakao.com/sdk/js/kakao.js';
    document.body.appendChild(script);
  }, []);
  return (
    <>
      <Seo />
      <Header />
      <Body pathname={pathname}>{children}</Body>
      <AlertArea />
      <BackgroundArea />
      {/* <Footer /> */}
    </>
  );
}

export default Layout;
